import Splide from "@splidejs/splide";
import "@splidejs/splide/css/core";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
const Slider = () => {
    homeBannerSlider();
    logosSlider();
    statsSlider();
    testimonialsSlider();
    iconCardSlider();
    mapSlider();
    gallerySlider();
};
const homeBannerSlider = () => {
    const homeBannerSlider = document.querySelector(".js-home-banner-slider");
    const homeBannerImagesSlider = document.querySelector(".js-home-banner-images");
    if (!homeBannerSlider || !homeBannerImagesSlider)
        return;
    const homeBannerSliderInstance = new Splide(homeBannerSlider, {
        type: "loop",
        arrows: false,
        pagination: false,
        keyboard: false,
        drag: false,
        rewind: false,
        autoplay: true,
        speed: 1000,
        interval: 7500,
        pauseOnHover: false,
        pauseOnFocus: false,
        snap: true,
    }).mount();
    const homeBannerImagesSliderInstance = new Splide(homeBannerImagesSlider, {
        type: "fade",
        arrows: false,
        pagination: false,
        speed: 1000,
        interval: 7500,
    }).mount();
    homeBannerSliderInstance.sync(homeBannerImagesSliderInstance);
    const paginationButtons = document.querySelectorAll(".splide__pagination__page");
    // Handle custom pagination clicks
    paginationButtons.forEach((button, index) => {
        if (index === 0) {
            button.classList.add("is-active");
        }
        button.addEventListener("click", () => {
            const slideIndex = parseInt(button.dataset.slideIndex ?? "0");
            homeBannerSliderInstance.go(slideIndex);
        });
    });
    // Update active state when slide changes
    homeBannerSliderInstance.on("move", function (newIndex) {
        paginationButtons.forEach((button, index) => {
            if (index === newIndex) {
                button.classList.add("is-active");
                button.setAttribute("aria-selected", "true");
            }
            else {
                button.classList.remove("is-active");
                button.setAttribute("aria-selected", "false");
            }
        });
    });
};
const logosSlider = () => {
    const logosSlider = document.querySelectorAll(".js-logos");
    logosSlider.forEach((slider) => {
        if (!slider)
            return;
        new Splide(slider, {
            type: "loop",
            drag: "free",
            focus: "center",
            rewind: true,
            autoScroll: {
                pauseOnHover: false,
                pauseOnFocus: false,
                speed: 1,
            },
            perPage: 3,
            perMove: 1,
            pagination: false,
            gap: 20,
            arrows: false,
            mediaQuery: "min",
            breakpoints: {
                767: {
                    perPage: 4,
                },
                1024: {
                    perPage: 6,
                },
                1279: {
                    perPage: 6,
                    gap: 40,
                },
            },
        }).mount({ AutoScroll });
    });
};
const statsSlider = () => {
    const statsSlider = document.querySelector(".js-stats");
    if (!statsSlider)
        return;
    const statsSliderInstance = new Splide(statsSlider, {
        type: "loop",
        arrows: false,
        pagination: false,
        keyboard: false,
        drag: false,
        rewind: true,
        autoplay: true,
        speed: 1000,
        interval: 7500,
        pauseOnHover: false,
        pauseOnFocus: false,
        gap: 40,
        snap: true,
    }).mount();
    const paginationButtons = document.querySelectorAll(".js-stats-paging");
    // Handle custom pagination clicks
    paginationButtons.forEach((button, index) => {
        if (index === 0) {
            button.classList.add("is-active");
        }
        button.addEventListener("click", () => {
            const slideIndex = parseInt(button.dataset.slideIndex ?? "0");
            statsSliderInstance.go(slideIndex);
        });
    });
    // Update active state when slide changes
    statsSliderInstance.on("move", function (newIndex) {
        paginationButtons.forEach((button, index) => {
            if (index === newIndex) {
                button.classList.add("is-active");
                button.setAttribute("aria-selected", "true");
            }
            else {
                button.classList.remove("is-active");
                button.setAttribute("aria-selected", "false");
            }
        });
    });
};
const testimonialsSlider = () => {
    const testimonialsSliderBlock = document.querySelectorAll(".js-testimonials-block");
    testimonialsSliderBlock.forEach((block) => {
        const testimonialsSlider = block.querySelector(".js-testimonials-slider");
        const testimonialsImagesSlider = block.querySelector(".js-testimonial-images");
        if (!testimonialsSlider || !testimonialsImagesSlider)
            return;
        const testimonialsSliderInstance = new Splide(testimonialsSlider, {
            type: "loop",
            arrows: false,
            pagination: false,
            keyboard: false,
            drag: false,
            rewind: false,
            autoplay: true,
            speed: 1000,
            interval: 7500,
            pauseOnHover: false,
            pauseOnFocus: false,
            gap: 40,
            snap: true,
        }).mount();
        const testimonialsImagesSliderInstance = new Splide(testimonialsImagesSlider, {
            type: "fade",
            arrows: false,
            pagination: false,
            speed: 1000,
            interval: 7500,
        }).mount();
        testimonialsSliderInstance.sync(testimonialsImagesSliderInstance);
        const paginationButtons = block.querySelectorAll(".js-testimonials-paging");
        // Handle custom pagination clicks
        paginationButtons.forEach((button, index) => {
            if (index === 0) {
                button.classList.add("is-active-slide");
            }
            button.addEventListener("click", () => {
                const slideIndex = parseInt(button.dataset.slideIndex ?? "0");
                testimonialsSliderInstance.go(slideIndex);
            });
        });
        // Update active state when slide changes
        testimonialsSliderInstance.on("move", function (newIndex) {
            paginationButtons.forEach((button, index) => {
                if (index === newIndex) {
                    button.classList.add("is-active-slide");
                    button.setAttribute("aria-selected", "true");
                }
                else {
                    button.classList.remove("is-active-slide");
                    button.setAttribute("aria-selected", "false");
                }
            });
        });
    });
};
const iconCardSlider = () => {
    const iconCardSlider = document.querySelectorAll(".js-card-slider");
    if (!iconCardSlider || !iconCardSlider.length)
        return;
    iconCardSlider.forEach((slider) => {
        new Splide(slider, {
            type: "loop",
            drag: "free",
            focus: "center",
            rewind: true,
            autoScroll: {
                pauseOnHover: true,
                pauseOnFocus: false,
                speed: 0.4,
            },
            perPage: 1,
            perMove: 1,
            pagination: false,
            gap: 20,
            arrows: false,
            mediaQuery: "min",
            breakpoints: {
                767: {
                    perPage: 2,
                },
                1023: {
                    perPage: 3,
                },
                1279: {
                    perPage: 4,
                },
            },
        }).mount({ AutoScroll });
    });
};
const mapSlider = () => {
    const mapImagesSlider = document.querySelector(".js-map-images");
    if (!mapImagesSlider)
        return;
    const mapImagesSliderInstance = new Splide(mapImagesSlider, {
        type: "fade",
        arrows: false,
        pagination: false,
        keyboard: false,
        drag: true,
        rewind: true,
        speed: 500,
        pauseOnHover: false,
        snap: true,
        autoplay: false,
        autoHeight: true,
    }).mount();
    const mapLocationsSlider = document.querySelector(".js-map-locations");
    if (!mapLocationsSlider)
        return;
    const mapLocationsSliderInstance = new Splide(mapLocationsSlider, {
        type: "fade",
        arrows: false,
        drag: false,
        autoplay: false,
    }).mount();
    mapImagesSliderInstance.sync(mapLocationsSliderInstance);
    const paginationButtons = document.querySelectorAll(".js-map-pagination");
    // Handle custom pagination clicks
    paginationButtons.forEach((button, index) => {
        if (index === 0) {
            button.classList.add("is-active");
        }
        button.addEventListener("click", () => {
            const slideIndex = parseInt(button.dataset.slideIndex ?? "0");
            mapImagesSliderInstance.go(slideIndex);
        });
    });
    // Update active state when slide changes
    mapImagesSliderInstance.on("move", function (newIndex) {
        paginationButtons.forEach((button, index) => {
            if (index === newIndex) {
                button.classList.add("is-active");
                button.setAttribute("aria-selected", "true");
            }
            else {
                button.classList.remove("is-active");
                button.setAttribute("aria-selected", "false");
            }
        });
    });
};
const gallerySlider = () => {
    const galleryBlocks = document.querySelectorAll(".js-gallery-block");
    galleryBlocks.forEach((block) => {
        const productGallery = block.querySelector(".js-product-gallery-main");
        const productGalleryThumbs = block.querySelector(".js-product-gallery-thumbs");
        if (productGallery && productGalleryThumbs) {
            let main = new Splide(productGallery, {
                type: "fade",
                loop: true,
                arrows: false,
                pagination: false,
                perPage: 1,
                perMove: 1,
                autoplay: true,
                start: 1,
            });
            let thumbs = new Splide(productGalleryThumbs, {
                type: "loop",
                isNavigation: true,
                gap: 10,
                pagination: false,
                perPage: 3,
                arrows: false,
                mediaQuery: "min",
                start: 1,
                breakpoints: {
                    767: {
                        perPage: 4,
                    },
                },
            });
            main.sync(thumbs);
            main.mount();
            thumbs.mount();
            const updateThumbsPagination = (index) => {
                const activeThumbnail = productGalleryThumbs.querySelectorAll(".is-active");
                if (!activeThumbnail)
                    return;
                const newIndex = index + 1 > main.length - 1 ? 0 : index + 1;
                activeThumbnail.forEach((active) => {
                    active.addEventListener("click", () => {
                        main.go(newIndex);
                    });
                });
            };
            updateThumbsPagination(1);
            thumbs.on("moved", (index) => {
                updateThumbsPagination(index);
            });
        }
    });
};
export default Slider;
